/**
 * Vue 404, rendue pour toute URL inconnue. Bilingue en dur : elle peut s'afficher
 * avant que le contexte de langue ne soit disponible (erreur de route).
 */
const NotFound = () => (
  <div style={{ padding: "2rem", textAlign: "center" }}>
    <h1>404</h1>
    <p>Cette page n&apos;existe pas. / This page does not exist.</p>
    <a href="/">Retour à l&apos;accueil / Back to home</a>
  </div>
);

export default NotFound;
